import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { I18NextService } from 'angular-i18next';
import { TaskState } from '../../enums/task-state.enum';
import { ReportType } from '@modeso/types__aumico-lib-annualreport-be/dist/models/enums/report-type.enum';

@Component({
    selector: 'report-type-filter-drop-down',
    templateUrl: './report-type-filter-drop-down.component.html',
    styleUrls: ['./report-type-filter-drop-down.component.scss'],
})
export class ReportTypeFilterDropDown {
    @Input() selectedReportType: ReportType[] = [];
    @Output() statusChange = new EventEmitter<ReportType[]>();

    openedFlyout = false;

    @Input() rightAlignment: boolean = false;

    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    @Input() reportTypeOptions = [
        { label: 'Annual Report', value: ReportType.ANNUAL },
        { label: 'Quarterly Report', value: ReportType.QUARTERLY },
        { label: 'Monthly Report', value: ReportType.MONTHLY },
        { label: 'Custom Report', value: ReportType.CUSTOM },
    ];

    isFilterActive: boolean = this.selectedReportType.length > 0;

    constructor(private readonly localizedTexts: I18NextService) {
        this.reportTypeOptions[0].label = this.localizedTexts.t('aumico_po_report_type_annual') as string;
        this.reportTypeOptions[1].label = this.localizedTexts.t('aumico_po_report_type_quarterly') as string;
        this.reportTypeOptions[2].label = this.localizedTexts.t('aumico_po_report_type_monthly') as string;
        this.reportTypeOptions[3].label = this.localizedTexts.t('aumico_po_report_type_custom') as string;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedReportType']) {
            this.isFilterActive = this.selectedReportType.length > 0;
        }
    }

    toggleStatusSelection(value: ReportType): void {
        const isCurrentlySelected = this.selectedReportType.includes(value);
        this.onStatusSelection(value, !isCurrentlySelected);
    }

    onStatusSelection(value: ReportType, checked: boolean) {
        if (checked) {
            this.selectedReportType.push(value);
        } else {
            this.selectedReportType = this.selectedReportType.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        const diffrence = rect.left - rect.right;

        if (this.rightAlignment) {
            this.flyoutPosition.left += diffrence;
        }

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedReportType.length > 0;
        this.closeFlyout();
        this.statusChange.emit(this.selectedReportType);
    }

    clearFilter(): void {
        this.selectedReportType = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.statusChange.emit(this.selectedReportType);
    }
}
